import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface ISearchIconProps extends ISvgIconProps {

}

export class SearchIcon extends React.Component<ISearchIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props} flipOnRTL viewBox="0 0 16 16">
                <g fill="none">
                    <path d="M6.44299 11.886C3.4369 11.886 0.999987 9.44909 0.999987 6.443C0.999987 3.43691 3.4369 1 6.44299 1C9.44907 1 11.886 3.43691 11.886 6.443C11.886 9.44909 9.44907 11.886 6.44299 11.886Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.2915 10.292L13.7825 14.049" stroke="currentColor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
                </g>
            </SvgIcon>
        );
    }
}
